import { motion } from "framer-motion";
import { PHOTOS } from "./assets";

export default function FinalCTA() {
  const scrollTo = () =>
    document.querySelector("#assessment")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="start"
      data-testid="final-cta-section"
      className="relative min-h-[85vh] flex items-center overflow-hidden border-t border-white/10"
    >
      <div className="absolute inset-0">
        <img
          src={PHOTOS.youth}
          alt="Athletes training together"
          loading="lazy"
          className="w-full h-full object-cover object-[center_40%] grayscale"
        />
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full text-center">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-8xl mx-auto max-w-4xl"
          data-testid="final-cta-title"
        >
          Speed isn't just a skill.
          <br />
          <span className="text-white/60">It's confidence.</span>{" "}
          <span className="text-white/60">It's opportunity.</span>
          <br />
          It's separation.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="mt-12"
        >
          <button
            data-testid="final-cta-btn"
            onClick={scrollTo}
            className="bg-white text-black uppercase tracking-[0.25em] font-bold text-sm px-14 py-6 transition-transform duration-300 hover:scale-[1.03]"
          >
            Start Training
          </button>
        </motion.div>
      </div>
    </section>
  );
}
